import React, {useState} from 'react'
import './contactcontent.less'
import {AiFillPhone} from 'react-icons/ai'
import {FaEnvelope} from 'react-icons/fa'

export default ()=>{
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');

    return(
        <section className="contact-content">
            <article className="contact-message-container anim-three" data-delay="0s">
                <p className="contact-text anim-three" data-delay="0.2s">
                    Always here to listen! If you need help or if you are willing to help, feel free to get in touch with us. Together,
                    let's make a difference.
                    If you are led to donate to this cause in any way, join hands with us as we strive to expand our outreach and support
                    people who truly deserve it. May you be blessed to be a blessing to others.
                    <br/>
                    <br/>
                    Leave us a message if you have any queries and we’ll get back to you as fast as we could!
                </p>
            </article>
            <div class="contact-container anim-three" data-delay="0s">
                <article class="contact-info">
                    <div class="single-info anim-three" data-delay="0.2s">
                        <span class="contact-icon">
                            <FaEnvelope/> Email
                        </span>
                        <p class="contact-detail">
                            info@theempowerinitiative.lk
                        </p>
                    </div>
                    <div class="single-info anim-three" data-delay="0.4s">
                        <span class="contact-icon">
                            <AiFillPhone/> Telephone
                        </span>
                        <p class="contact-detail">
                            +94 77 876 0802
                        </p>
                    </div>
                </article>
                <article className="form-container anim-three" data-delay="0s">
                    <form action="https://formspree.io/f/mbjpzypr" method="POST" name="Contact Form">
                        <article className="form-grid">
                            <div className="anim-three" data-delay="0.2s">
                                <input type="text" id="firstname" className={`${firstName? "has-content": ""}`} name="First Name" value={firstName} onChange={e => setFirstName(e.target.value)} required/>
                                <label htmlFor="firstname">First Name</label>
                            </div>
                            <div className="anim-three" data-delay="0.4s">
                                <input type="text" id="lastname" className={`${lastName? "has-content": ""}`} name="Last Name" value={lastName} onChange={e => setLastName(e.target.value)}/>
                                <label htmlFor="lastname">Last Name</label>
                            </div>
                        </article>
                        <article className="form-grid">
                            <div className="anim-three" data-delay="0.6s">
                                <input type="email" id="email" className={`${email? "has-content": ""}`} name="Email" value={email} onChange={e => setEmail(e.target.value)} required/>
                                <label htmlFor="email">Email</label>
                            </div>
                            <div className="anim-three" data-delay="0.8s">
                                <input type="tel" id="phone" className={`${phone? "has-content": ""}`} name="Telephone" value={phone} onChange={e => setPhone(e.target.value)}/>
                                <label htmlFor="phone">Phone</label>
                            </div>
                        </article>
                        <div className="anim-three" data-delay="1.0s">
                            <input type="text" id="subject" className={`${subject? "has-content": ""}`} name="Subject" value={subject} onChange={e => setSubject(e.target.value)}/>
                            <label htmlFor="subject">Subject</label>
                        </div>
                        <div className="anim-three" data-delay="1.2s">
                            <input type="textarea" cols="30" rows="10" id="message" className={`textarea ${message? "has-content": ""}`} name="Message" value={message} onChange={e => setMessage(e.target.value)}/>
                            <label htmlFor="message">Message</label>
                        </div>
                        <input type="submit" value="Submit" className="btn anim-three"  data-delay="1.4s"/>
                    </form>
                </article>
            </div>
        </section>
    )
}